module.exports = __webpack_public_path__ + "media/img/tomedo-logo-4825c6b76c79108f36390b1beb0be1a0.svg";